export const MSGCONSTANT = {
    success: "success",
    error: "something went wrong!",
}